import { Outlet } from "react-router-dom";

const SponsorshipListingMain = (props: any) => {

    return (
        <>
            <Outlet />
        </>
    );
}

export default SponsorshipListingMain;